// extracted by mini-css-extract-plugin
export default {"aside":"SideBar_aside__ppp26","content":"SideBar_content__SHTvb","user_info":"SideBar_user_info__xxcfZ","close":"SideBar_close__jEk77"};